import { gql } from "lib/apolloClient";

export const organizationFragments = {
  organizationFeedDetailsItem: gql`
    fragment organizationFeedDetailsItem on Organization {
      id
      name
      curriculumPrograms {
        id
        label
        acronym
        type
        __typename
      }
      __typename
    }
  `,
  organizationGlobalConstants: gql`
    fragment organizationGlobalConstantItem on OrganizationGlobalConstants {
      id
      name
      value
      curriculumProgram {
        id
        type
        label
        acronym
      }
    }
  `,
};
